export const GROUP_NAME = 'input-textarea'
